import React from "react"

import VideoPlayer from "../../../../../components/Quick_Installation/Videos/video-wps-fritzbox"

import SEOHelmet from '../../../../../components/Layout/SEOHelmet'
import Footer from "../../../../../components/Layout/footer"

const seodata = {
  title: 'Fritz!Box WPS :: Set up a Wireless Connection',
  description: 'Our 720p and 1080p cameras allow you to use your router´s WPS function to connect them directly to your WiFi network.',
  image: '/images/Search/QI_SearchThumb_WLAN.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
    <h1 id="introduction" style={{ marginTop: 0 }}>
      WPS / WLAN Schnellverbindung mit einer AVM Fritz!Box
    </h1>
    <VideoPlayer />
    <br />
    <br />
    <Footer
      previousTitle="Quick Installation"
      previousLink="/fr/Quick_Installation/"
      nextTitle="WPS Plug & Play"
      nextLink="/fr/Quick_Installation/Set_Up_A_Wireless_Connection/WPS_Plug_and_Play/" />
  </React.Fragment>
)